import React from "react";
import { Popup } from "react-map-gl";
import { getBoundaryStyle } from "./MapStyles";

export const ntaToolTip = ({ ntaName, ntaGeometry }) => {
  const nta = ntaName;
  //const polygon = ntaGeometry;
  return (
    <Popup
      style={getBoundaryStyle}
      closeButton={false}
      className="article-info"
      closeOnClick={false}
    >
      <div className="popup-content">
        <p>
          {" "}
          <b>Neighborhood:</b> {nta}{" "}
        </p>
        <p>
          {" "}
          <b>Population Density as per 2020 Census:</b> 30,000{" "}
        </p>
      </div>
    </Popup>
  );
};

export const Tooltip = ({ hoverInfo, hoverLat, hoverLong }) => {
  const headline = hoverInfo;
  const longitude = hoverLong;
  const latitude = hoverLat;
  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      closeButton={false}
      className="article-info"
      closeOnClick={false}
    >
      <div className="popup-content">
        <p>
          {" "}
          <b>HEADLINE:</b> {headline}{" "}
        </p>
      </div>
    </Popup>
  );
};
